module.exports = __webpack_public_path__ + "assets/img/rtf.8385e1c2.svg";